import axios from "axios";
import React, { useEffect, useState } from "react";
import {useHistory } from "react-router-dom";
import swal from "sweetalert";

const ViewUser = (props) => {
    document.title = "DirtMap - User Details";

    const history = useHistory();
   // const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState([]);

    //console.log(id);
    useEffect(() => {
       let isMounted  = true;
        axios.get(`api/get/profile/${props.match.params.id}`).then(res => {
            if(isMounted) {
                if (res.data.result) {
                    setUser(res.data.result);
                    console.log(res.data.result);
                    setLoading(false);
                } else if (res.data.status === 'false') {
                    history.push('/');
                    swal("warning", res.data.message, "error");
                }
            }
            
        });
        return () => {
            isMounted = false;
        };
    }, [props.match.params.id, history]);

    if(loading) {
        return <h4>Loading User Details...</h4>
    } else {

    }
    return (
        <main className="main">
            <div className="container-fluid">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                        <div className="row align-items-center">
                            <div className="col-sm-12">
                                <h4 className="card-title mb-0"> User Details</h4>
                            </div>

                        </div>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered" width="100%">
                               
                                <tbody>
                                    <tr>
                                        <th >User Name:</th>
                                        <td>{user.first_name}{user.last_name}</td>
                                    </tr>
                                    <tr>
                                        <th >Email:</th>
                                        <td>{user.email}</td>
                                    </tr>
                                    <tr>
                                        <th >Street Address:</th>
                                        <td>{user.street_address}</td>
                                    </tr>
                                    <tr>
                                        <th >Street Address 2:</th>
                                        <td>{user.street_address_2}</td>
                                    </tr>
                                    <tr>
                                        <th >Country:</th>
                                        <td>{user.country}</td>
                                    </tr>
                                    <tr>
                                        <th >State:</th>
                                        <td>{user.state}</td>
                                    </tr>
                                    <tr>
                                        <th >City:</th>
                                        <td>{user.city}</td>
                                    </tr>
                                    <tr>
                                        <th >Mobile Number:</th>
                                        <td>{user.phone_number}</td>
                                    </tr>
                                    <tr>
                                        <th >Zipcode:</th>
                                        <td>{user.zipcode}</td>
                                    </tr>
                                    <tr>
                                        <th >User Type:</th>
                                        <td>{user.user_type}</td>
                                    </tr>

                                    <tr>
                                        <th>Status:</th>
                                        <td className="center">
                                        {user.status === '1' ? 'Active' : 'Inactive'}  
                                        </td>
                                    </tr>
                                </tbody>


                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )
}

export default ViewUser;